<div class="modal-body">
    <mdb-card>
          <mdb-card-body>
              <div class="form-row mb-3">
                <div class="col-3">Correo Institucional:</div>
                <div class="col-7">
                  <input mdbInput readonly type="text" maxlength="200"  class="form-control" [(ngModel)]="maeUsuarioE.x_usuario" placeholder="">
                </div>
                <div class="col-2">
                    <span>@bnp.gob.pe</span>
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Nro Documento:</div>
                <div class="col-9">
                  <input mdbInput type="text" readonly maxlength="200"  class="form-control" [(ngModel)]="maeUsuarioE.x_nro_documento" placeholder="">
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Nombres:</div>
                <div class="col-9">
                  <input mdbInput type="text" readonly maxlength="200"  class="form-control" [(ngModel)]="maeUsuarioE.x_nombres" placeholder="">
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Apellido Paterno:</div>
                <div class="col-9">
                  <input mdbInput type="text" readonly maxlength="200"  class="form-control" [(ngModel)]="maeUsuarioE.x_ape_pat" placeholder="">
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Apellido Materno:</div>
                <div class="col-9">
                  <input mdbInput type="text" readonly maxlength="200"  class="form-control" [(ngModel)]="maeUsuarioE.x_ape_mat" placeholder="">
                </div>
              </div>
              <div class="form-row mb-3">
                  <div class="col-3">Organo:</div>
                  <div class="col-9">
                    <select class="browser-default custom-select" disabled [(ngModel)]="maeUsuarioE.c_oficina">
                        <option value="0" selected>Seleccione</option>
                        <option *ngFor="let listOrgano of listOrgano" [value]="listOrgano.c_tabla">{{listOrgano.x_valor}}</option>
                    </select>
                  </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Perfil:</div>
                <div class="col-9">
                    <select class="browser-default custom-select" disabled [(ngModel)]="maeUsuarioE.c_perfil">
                        <option value="0" selected>Seleccione</option>
                        <option *ngFor="let listPerfil of listPerfil" [value]="listPerfil.c_tabla">{{listPerfil.x_valor}}</option>
                    </select>
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Estado:</div>
                <div class="col-9">
                    <select class="browser-default custom-select" disabled [(ngModel)]="maeUsuarioE.c_estado">
                        <option value="0" selected>Seleccione</option>
                        <option *ngFor="let listEstado of listEstado" [value]="listEstado.c_tabla">{{listEstado.x_valor}}</option>
                    </select>
                </div>
              </div>
          </mdb-card-body>
</mdb-card>
</div>
